import React, { useState, useContext } from "react";
import { Modal, Form, Row, Col, Button } from "react-bootstrap";
import { formatDateInDDMMYYYY, getCurrentDatewithTime } from "../../functions/common-functions";
import { AuthContext } from "../../contexts/AuthContext";
import { placeBidUpdate } from "../../services/maintain-bid-service";
import { getPresignedURL } from "../../functions/upload";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import successImage from "../../icons/success-tick-logo.svg";
import errorImage from "../../icons/error-tick-logo.svg";
import { addLogDetails } from "../../services/logger-entry-service";
import { encryptData } from "../../utils/encryption";

const PlaceBidModal = ({ show, onHide, enquiry, setReload, reload }) => {
  console.log("Enquiry", enquiry)
  const MySwal = withReactContent(Swal);
  const context = useContext(AuthContext);
  const [placeBid, setPlaceBid] = useState("");
  const [regret, setRegret] = useState(false);

  const contractType = enquiry.EnquirySource === "Contract" ? "Contract Item" : "Non-Contract Item";
  const currentBid = enquiry.CurrentBid === "Regret" ? "Regret" : enquiry.CurrentBid || "No bid placed";

  const getTermsAndConditions = () => {
    if (enquiry.EnquirySource === "Contract") {
      return `Contract Items
    1.   The contract will be valid for ${enquiry.ContractPeriod} months from the date of award.
    2.  Scrap shall be disposed of on “as is where is” basis.
    3.  Bidders must submit their best offer for all applicable scrap categories through the online portal only (link provided in the mail).
    4.  Lifting, loading, and transportation of scrap will be under the buyer’s scope and responsibility.
    5.  The buyer shall comply with all applicable statutory, safety, and environmental norms during scrap handling and lifting.
    6.  Payment terms: [Advance / On Delivery].
    7.  GST and any other applicable taxes will be extra.
    8.  Workmen’s compensation policy or ESIC of labour employed by the buyer must be submitted to the Company.
    9.  Rate revision, if any, will not be entertained during the contract period.
    10. Any non-performance or deviation from agreed terms may result in termination of the contract and forfeiture of Security Deposit, as per the terms of the Contract Agreement.
    Kindly ensure that your offer is submitted through the above link on or before the due date.
`;
    } else {
      return `Non-Contract Items
    1.   Scrap shall be disposed of on “as is where is” basis.
    2.  Bidders must submit their best offer for all applicable scrap categories through the online portal only (link provided in the mail).
    3.  Lifting, loading, and transportation of scrap will be under the buyer’s scope and responsibility.
    4.  The buyer shall comply with all applicable statutory, safety, and environmental norms during scrap handling and lifting.
    5.  Payment terms: [Advance / On Delivery].
    6.  GST and any other applicable taxes will be extra.
    7.  Workmen’s compensation policy or ESIC of labour employed by the buyer must be submitted to the Company.
    8.  Rate revision, if any, will not be entertained after the item is finalized and allotted.
    9.  Any non-performance or deviation from agreed terms may result in cancellation of the awarded item, and appropriate action may be taken             as deemed necessary by the management.
    Kindly ensure that your offer is submitted through the above link on or before the due date.
`;
    }
  };


  const handleBidChange = (e) => {
    const value = e.target.value;
    if (value === "" || /^\d*\.?\d{0,2}$/.test(value)) {
      setPlaceBid(value);
    }
  };

  const handleRegretChange = (e) => {
    const checked = e.target.checked;
    setRegret(checked);
    if (checked) {
      setPlaceBid("");
    }
  };

  const handleFileDownload = async (fileName) => {
    try {
      const enquiryNumber = enquiry.EnquiryNumber;
      const disposalNumber = enquiry.EnquirySourceNumber;
      const filePath = `EnquiryTender/${enquiryNumber.replace(/\//g, '_')}/${fileName}`;
      if (!filePath) {
        const filePath = `DisposalIntimation/${disposalNumber.replace(/\//g, '_')}/${fileName}`
      }
      const downloadURL = await getPresignedURL(filePath);
      if (downloadURL) {
        window.open(downloadURL, '_blank');
      }
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const handleSubmit = async () => {
    if (!placeBid && !regret) {
      MySwal.fire({
        text: "Please enter bid in Place Bid or check the Regret checkbox",
        imageUrl: errorImage,
        customClass: "swal-error"
      });
      return;
    }

    if (placeBid && parseFloat(placeBid) <= 0) {
      MySwal.fire({
        text: "Bid amount must be greater than zero",
        imageUrl: errorImage,
        customClass: "swal-error"
      });
      return;
    }

    MySwal.fire({
      title: "Submit Quotation",
      text: "Are you sure you want to submit this quotation?",
      showCancelButton: true,
      confirmButtonText: "Submit",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#810055",
      reverseButtons: true,
      customClass: "swal-confirmation"
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const todayDate = getCurrentDatewithTime()
          const updatedEnquiry = {
            ...enquiry,
            CurrentBid: regret ? "Regret" : encryptData(placeBid),
            CurrentBidDate: todayDate,
            ModifiedBy: context.userId,
            ModifiedByName: context.userName,
            ModifiedOn: todayDate
          };

          const apiResult = await placeBidUpdate(updatedEnquiry);

          if (apiResult.status) {
            await addLogDetails(updatedEnquiry, "PlaceBid", enquiry.EnquiryNumber, "BidLog", { userName: context.userName, userId: context.userId }, "Transaction");

            MySwal.fire({
              text: "Bid submitted successfully",
              imageUrl: successImage,
              customClass: "swal-success"
            });
            onHide();
            setReload(!reload);
          } else {
            MySwal.fire({
              text: apiResult.message,
              imageUrl: errorImage,
              customClass: "swal-error"
            });
          }
        } catch (error) {
          MySwal.fire({
            text: "Unable to submit bid",
            imageUrl: errorImage,
            customClass: "swal-error"
          });
        }
      }
    });
  };

  return (
    <Modal show={show} onHide={onHide} size="xl" backdrop="static" centered>
      <Modal.Header closeButton>
        <Modal.Title>Place Bid</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row>
            <Col lg={6} xs={12}>
              <Form.Group className="g-input">
                <Form.Control
                  type="text"
                  value={enquiry.CustomerCode || ""}
                  readOnly
                  placeholder=" "
                />
                <Form.Label>Customer Code</Form.Label>
              </Form.Group>
            </Col>
            <Col lg={6} xs={12}>
              <Form.Group className="g-input">
                <Form.Control
                  type="text"
                  value={enquiry.CustomerName || enquiry.LinkedBPName || ""}
                  readOnly
                  placeholder=" "
                />
                <Form.Label>Customer Name</Form.Label>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col lg={6} xs={12}>
              <Form.Group className="g-input">
                <Form.Control
                  type="text"
                  value={enquiry.EnquiryNumber}
                  readOnly
                  placeholder=" "
                />
                <Form.Label>Enquiry Number</Form.Label>
              </Form.Group>
            </Col>
            <Col lg={6} xs={12}>
              <Form.Group className="g-input">
                <Form.Control
                  type="text"
                  value={contractType}
                  readOnly
                  placeholder=" "
                />
                <Form.Label>Contract/Non-Contract</Form.Label>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col lg={4} xs={12}>
              <Form.Group className="g-input">
                <Form.Control
                  type="text"
                  value={enquiry.ItemCode}
                  readOnly
                  placeholder=" "
                />
                <Form.Label>Item Code</Form.Label>
              </Form.Group>
            </Col>
            <Col lg={4} xs={12}>
              <Form.Group className="g-input">
                <Form.Control
                  type="text"
                  value={enquiry.ItemDescription}
                  readOnly
                  placeholder=" "
                />
                <Form.Label>Item Description</Form.Label>
              </Form.Group>
            </Col>
            <Col lg={4} xs={12}>
              <Form.Group className="g-input">
                <Form.Control
                  id="ItemType"
                  type="text"
                  name="ItemType"
                  placeholder=" "
                  value={enquiry.ItemType}
                  readOnly
                />
                <Form.Label htmlFor="Division">Item Type</Form.Label>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col lg={12} xs={12}>
              <Form.Group className="g-input">
                <Form.Control
                  as="textarea"
                  rows={1}
                  value={enquiry.ItemDetail}
                  readOnly
                  placeholder=" "
                />
                <Form.Label>Item Detail</Form.Label>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col lg={4} xs={12}>
              <Form.Group className="g-input">
                <Form.Control
                  type="text"
                  value={enquiry.Quantity}
                  readOnly
                  placeholder=" "
                />
                <Form.Label>Quantity</Form.Label>
              </Form.Group>
            </Col>
            <Col lg={4} xs={12}>
              <Form.Group className="g-input">
                <Form.Control
                  type="text"
                  value={enquiry.UOM}
                  readOnly
                  placeholder=" "
                />
                <Form.Label>UOM</Form.Label>
              </Form.Group>
            </Col>
            <Col lg={4} xs={12}>
              <Form.Group className="g-input">
                <Form.Control
                  type="text"
                  value={enquiry.GST}
                  readOnly
                  placeholder=" "
                />
                <Form.Label>GST%</Form.Label>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col lg={4} xs={12}>
              <Form.Group className="g-input">
                <Form.Control
                  id="Division"
                  type="text"
                  name="Division"
                  placeholder=" "
                  value={enquiry.Division}
                  readOnly
                />
                <Form.Label htmlFor="Division">Division</Form.Label>
              </Form.Group>
            </Col>
            <Col lg={4} xs={12}>
              <Form.Group className="g-input">
                <Form.Control
                  type="text"
                  value={enquiry.Location}
                  readOnly
                  placeholder=" "
                />
                <Form.Label>Location</Form.Label>
              </Form.Group>
            </Col>
            <Col lg={4} xs={12}>
              <Form.Group className="g-input">
                <Form.Control
                  id="LogisticCompany"
                  type="text"
                  name="LogisticCompany"
                  placeholder=" "
                  value={enquiry.LogisticCompany}
                  readOnly
                />
                <Form.Label htmlFor="LogisticCompany">Logistic Company</Form.Label>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col lg={4} xs={12}>
              <Form.Group className="g-input">
                <Form.Control
                  as="textarea"
                  rows={1}
                  value={enquiry.Remarks || ""}
                  readOnly
                  placeholder=" "
                />
                <Form.Label>Remarks</Form.Label>
              </Form.Group>
            </Col>            
            <Col lg={4} xs={12}>
              <Form.Group className="g-input">
                <Form.Control
                  type="text"
                  value={enquiry.DueDate ? formatDateInDDMMYYYY(enquiry.DueDate) : ""}
                  readOnly
                  placeholder=" "
                />
                <Form.Label>Due Date</Form.Label>
              </Form.Group>
            </Col>
          </Row>

          {contractType === "Non-Contract Item" && (
            <>
              {enquiry.ShowAttachImage && enquiry.AttachImage && (

                <Col xs={4}>
                  <Form.Group className="g-input">
                    <Form.Control
                      type="text"
                      value={enquiry.AttachImage}
                      readOnly
                      placeholder=" "
                      style={{ cursor: 'pointer', color: '#007bff' }}
                      onClick={() => handleFileDownload(enquiry.AttachImage)}
                    />
                    <Form.Label>Attachment 1</Form.Label>
                  </Form.Group>
                </Col>

              )}
              {enquiry.ShowAttachDocument1 && enquiry.AttachDocument1 && (

                <Col xs={4}>
                  <Form.Group className="g-input">
                    <Form.Control
                      type="text"
                      value={enquiry.AttachDocument1}
                      readOnly
                      placeholder=" "
                      style={{ cursor: 'pointer', color: '#007bff' }}
                      onClick={() => handleFileDownload(enquiry.AttachDocument1)}
                    />
                    <Form.Label>Attachment 2</Form.Label>
                  </Form.Group>
                </Col>

              )}
              {enquiry.ShowAttachDocument2 && enquiry.AttachDocument2 && (

                <Col xs={4}>
                  <Form.Group className="g-input">
                    <Form.Control
                      type="text"
                      value={enquiry.AttachDocument2}
                      readOnly
                      placeholder=" "
                      style={{ cursor: 'pointer', color: '#007bff' }}
                      onClick={() => handleFileDownload(enquiry.AttachDocument2)}
                    />
                    <Form.Label>Attachment 3</Form.Label>
                  </Form.Group>
                </Col>

              )}
              {enquiry.ShowAttachDocument3 && enquiry.AttachDocument3 && (

                <Col xs={4}>
                  <Form.Group className="g-input">
                    <Form.Control
                      type="text"
                      value={enquiry.AttachDocument3}
                      readOnly
                      placeholder=" "
                      style={{ cursor: 'pointer', color: '#007bff' }}
                      onClick={() => handleFileDownload(enquiry.AttachDocument3)}
                    />
                    <Form.Label>Attachment 4</Form.Label>
                  </Form.Group>
                </Col>

              )}
            </>
          )}

          {enquiry.EnquirySource === "Contract" && enquiry.ShowImageToCustomer && (
            <Row>
              <Col xs={4}>
                <Form.Group className="g-input">
                  <Form.Control
                    type="text"
                    value={enquiry.ImagesAttachment}
                    readOnly
                    placeholder=" "
                    style={{ cursor: 'pointer', color: '#007bff' }}
                    onClick={() => handleFileDownload(enquiry.ImagesAttachment)}
                  />
                  <Form.Label>Attachment 5</Form.Label>
                </Form.Group>
              </Col>
            </Row>
          )}

          {enquiry.EnquirySource === "Manual" && (
            <Row>
              <Col xs={4}>
                <Form.Group className="g-input">
                  <Form.Control
                    type="text"
                    value={enquiry.ImagesAttachment}
                    readOnly
                    placeholder=" "
                    style={{ cursor: 'pointer', color: '#007bff' }}
                    onClick={() => handleFileDownload(enquiry.ImagesAttachment)}
                  />
                  <Form.Label>Attachment 5</Form.Label>
                </Form.Group>
              </Col>
            </Row>
          )}

          <Row>
            <Col lg={4} xs={12}>
              <Form.Group className="approval-label">
                <Form.Control
                  type="text"
                  value={currentBid}
                  readOnly
                  placeholder=" "
                />
                <Form.Label>Current Bid</Form.Label>
              </Form.Group>
            </Col>
            <Col lg={4} xs={12}>
              <Form.Group className="approval-label">
                <Form.Control
                  type="text"
                  value={placeBid}
                  onChange={handleBidChange}
                  readOnly={regret}
                  placeholder=" "
                  maxLength={20}
                />
                <Form.Label>Place Bid </Form.Label>
              </Form.Group>
            </Col>
            <Col lg={4} xs={12}>
              <Form.Group className="approval-label">
                <Form.Check
                  type="checkbox"
                  label="Regret"
                  checked={regret}
                  onChange={handleRegretChange}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
          </Row>
          <Row>
            <Col xs={12}>
              <Form.Group className="g-input">
                <Form.Control
                  as="textarea"
                  rows={8}
                  value={getTermsAndConditions()}
                  readOnly
                  placeholder=" "
                />
                <Form.Label><b>Terms and Conditions</b></Form.Label>
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button className="semiBoldToggleButton cancelBtn" variant="outline-success" onClick={onHide}>
          Cancel
        </Button>
        <Button
          variant="success"
          className="btn-add-color-submit semiBoldToggleButton"
          onClick={handleSubmit}
        >
          Submit Quotation
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PlaceBidModal;
